import { fontWeights, paragraphSizes, ParagraphWithTooltip } from '@va/ui/design-system';

export const GroupHeaderCellV8 = ({ text }: { text: string }) => (
  <div className='-ml-2 pl-0.5 pr-2.5'>
    <div className='header-cell-content flex items-center justify-center w-full h-full py-1.5 bg-gray-mercury-darker rounded-t-lg'>
      <ParagraphWithTooltip
        weight={fontWeights.semibold}
        size={paragraphSizes.tiny}
        colorClassName='text-gray-devilSolid'
      >
        {text}
      </ParagraphWithTooltip>
    </div>
  </div>
);
